import { render, staticRenderFns } from "./TableBuyingInterest.vue?vue&type=template&id=6ed61cf4&scoped=true&"
import script from "./TableBuyingInterest.vue?vue&type=script&lang=js&"
export * from "./TableBuyingInterest.vue?vue&type=script&lang=js&"
import style0 from "./TableBuyingInterest.vue?vue&type=style&index=0&id=6ed61cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed61cf4",
  null
  
)

export default component.exports